/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import type {
  GetApiV1IndividualpaymentSharedParcelEnumsQueryResponse,
  GetApiV1IndividualpaymentSharedParcelEnumsQueryParams,
  GetApiV1IndividualpaymentSharedParcelEnums401,
  GetApiV1IndividualpaymentSharedParcelEnums500,
} from "../../types/individualPaymentSharedController/GetApiV1IndividualpaymentSharedParcelEnums.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { getApiV1IndividualpaymentSharedParcelEnums } from "../../clients/individualPaymentSharedController/getApiV1IndividualpaymentSharedParcelEnums.ts";

export const getApiV1IndividualpaymentSharedParcelEnumsQueryKey = (
  params?: GetApiV1IndividualpaymentSharedParcelEnumsQueryParams,
) =>
  [
    { url: "/api/v1/individualpayment/shared/parcel-enums" },
    ...(params ? [params] : []),
  ] as const;

export type GetApiV1IndividualpaymentSharedParcelEnumsQueryKey = ReturnType<
  typeof getApiV1IndividualpaymentSharedParcelEnumsQueryKey
>;

export function getApiV1IndividualpaymentSharedParcelEnumsQueryOptions(
  params?: GetApiV1IndividualpaymentSharedParcelEnumsQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey = getApiV1IndividualpaymentSharedParcelEnumsQueryKey(params);
  return queryOptions<
    GetApiV1IndividualpaymentSharedParcelEnumsQueryResponse,
    ResponseErrorConfig<
      | GetApiV1IndividualpaymentSharedParcelEnums401
      | GetApiV1IndividualpaymentSharedParcelEnums500
    >,
    GetApiV1IndividualpaymentSharedParcelEnumsQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return getApiV1IndividualpaymentSharedParcelEnums(params, {
        ...config,
        signal: config.signal ?? signal,
      });
    },
  });
}

/**
 * @description Retorna em uma única chamada as listas { key, value } dos enums usados no fluxo de parcela, com rótulo traduzido na cultura informada: 'types' (ETypePayment → campo 'typeId'), 'statuses' (EStatusPayment → campo 'statusId', inclui WaitingIntegration = 0), 'gridStatuses' (EFinancialGridParcelStatus → campo 'status' da grid, calculado a partir do status e do vencimento), 'paymentMethods' (EPaymentMethod completo → campo 'paymentMethod'), 'invoiceStatuses' (EStatusEnotas → 'status' de parcels/{id}/invoices) e 'transferTypes' (ETransferType). Atenção: em 'types', Registration (1) e Enrollment (2) compartilham o rótulo "Inscrição" desde o legado — as duas chaves são devolvidas porque ambas são valores válidos de 'typeId'. Para o dropdown restrito a boleto/cartão do plano use 'shared/payment-types'. Substitui as actions do EnumAsyncController do legado. **(Requer Authorization para autenticação)**
 * @summary Enums do fluxo de parcela (tipo, status, método de pagamento, status da NFe) (Requer Authorization para autenticação)
 * {@link /api/v1/individualpayment/shared/parcel-enums}
 */
export function useGetApiV1IndividualpaymentSharedParcelEnums<
  TData = GetApiV1IndividualpaymentSharedParcelEnumsQueryResponse,
  TQueryData = GetApiV1IndividualpaymentSharedParcelEnumsQueryResponse,
  TQueryKey extends QueryKey =
    GetApiV1IndividualpaymentSharedParcelEnumsQueryKey,
>(
  params?: GetApiV1IndividualpaymentSharedParcelEnumsQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiV1IndividualpaymentSharedParcelEnumsQueryResponse,
        ResponseErrorConfig<
          | GetApiV1IndividualpaymentSharedParcelEnums401
          | GetApiV1IndividualpaymentSharedParcelEnums500
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey =
    resolvedOptions?.queryKey ??
    getApiV1IndividualpaymentSharedParcelEnumsQueryKey(params);

  const query = useQuery(
    {
      ...getApiV1IndividualpaymentSharedParcelEnumsQueryOptions(params, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiV1IndividualpaymentSharedParcelEnums401
      | GetApiV1IndividualpaymentSharedParcelEnums500
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
